import React from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-cream pt-24 pb-12 px-6 md:px-12 lg:px-24 border-t border-charcoal/10" data-id="element-97">
      <div className="max-w-7xl mx-auto" data-id="element-98">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20" data-id="element-99">
          {/* Brand Column */}
          <div className="md:col-span-1" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/n8RBnThdh9nPmMgxYCad5H/PORTADAS_BLOGS_(3).png" alt="Aventuras por el Mundo" className="h-16 w-auto object-contain brightness-0 opacity-90 mb-6" data-id="element-101" />
            <p className="text-sm font-sans text-charcoal/60 leading-relaxed mb-8" data-id="element-102">
              Viajes diseñados exclusivamente para mujeres que buscan
              reconectar, explorar y compartir momentos inolvidables.
            </p>
            <div className="flex space-x-4 text-charcoal/50" data-id="element-103">
              <a href="https://www.instagram.com/aventurasporelmundo.cl/" target="_blank" rel="noopener noreferrer" className="hover:text-rose-primary transition-colors" data-id="element-104">
                <Instagram className="w-5 h-5" data-id="element-105" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-106">
            <h5 className="text-xs font-sans uppercase tracking-[0.2em] text-charcoal/40 mb-6" data-id="element-107">
              Navegación
            </h5>
            <ul className="space-y-4 text-sm font-sans text-charcoal/70" data-id="element-108">
              <li data-id="element-109">
                <a href="#inicio" className="hover:text-rose-primary transition-colors" data-id="element-110">
                  Inicio
                </a>
              </li>
              <li data-id="element-111">
                <a href="#nosotras" className="hover:text-rose-primary transition-colors" data-id="element-112">
                  Nosotras
                </a>
              </li>
              <li data-id="element-113">
                <a href="#experiencias" className="hover:text-rose-primary transition-colors" data-id="element-114">
                  Experiencias
                </a>
              </li>
              <li data-id="element-115">
                <a href="#contacto" className="hover:text-rose-primary transition-colors" data-id="element-116">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Sellos */}
          <div data-id="element-117">
            <h5 className="text-xs font-sans uppercase tracking-[0.2em] text-charcoal/40 mb-6" data-id="element-118">
              Certificaciones
            </h5>
            <div className="flex flex-row gap-6 items-center" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/pMf52kjBT731bWjLJfLTAq/2.png" alt="Sello Q de Calidad Turística" className="h-20 w-auto object-contain" data-id="element-120" />
              <img src="https://cdn.magicpatterns.com/uploads/4LSSxMBmfV6pS68QBAZVbF/3.png" alt="Protegemos a los niños, niñas y adolescentes" className="h-20 w-auto object-contain" data-id="element-121" />
            </div>
          </div>

          {/* Contacto */}
          <div data-id="element-122">
            <h5 className="text-xs font-sans uppercase tracking-[0.2em] text-charcoal/40 mb-6" data-id="element-123">
              Contacto
            </h5>
            <ul className="space-y-4 text-sm font-sans text-charcoal/70" data-id="element-124">
              <li data-id="element-125">ventas@aventurasporelmundo.cl</li>
              <li data-id="element-126">+56 9 6214 0004</li>
              <li data-id="element-127">Valparaíso, Chile</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-charcoal/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-128">
          <p className="font-sans text-xs text-charcoal/50" data-id="element-129">
            © {new Date().getFullYear()} Aventuras por el Mundo. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6 font-sans text-xs text-charcoal/50" data-id="element-130">
            <a href="#" className="hover:text-charcoal transition-colors" data-id="element-131">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-charcoal transition-colors" data-id="element-132">
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}